(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-read-more-toggle]');
    if (!toggle) return;

    const container = toggle.closest('.product-description__excerpt, .product-description__full')?.parentElement;
    if (!container) return;

    const expand = toggle.getAttribute('aria-expanded') === 'false';
    container.querySelector('.product-description__excerpt').hidden = expand;
    container.querySelector('.product-description__full').hidden = !expand;
    container.querySelector(expand ? '.product-description__full [data-read-more-toggle]' : '.product-description__excerpt [data-read-more-toggle]')?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
